var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInitiateReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.996 6.66477V5.33183C13.9957 5.09808 13.934 4.8685 13.8171 4.66613C13.7001 4.46375 13.5319 4.2957 13.3295 4.17883L8.66419 1.51293C8.46156 1.39594 8.2317 1.33435 7.99772 1.33435C7.76373 1.33435 7.53388 1.39594 7.33124 1.51293L2.66592 4.17883C2.46349 4.2957 2.29535 4.46375 2.17837 4.66613C2.06139 4.8685 1.99969 5.09808 1.99945 5.33183V10.6636C1.99969 10.8974 2.06139 11.1269 2.17837 11.3293C2.29535 11.5317 2.46349 11.6997 2.66592 11.8166L7.33124 14.4825C7.53388 14.5995 7.76373 14.6611 7.99772 14.6611C8.2317 14.6611 8.46156 14.5995 8.66419 14.4825L9.99714 13.7227",
    stroke: "white",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99854 2.84583L10.9968 6.27817",
    stroke: "white",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.19269 4.66528L7.99768 7.99765L13.8027 4.66528",
    stroke: "white",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99768 14.6624V7.99768",
    stroke: "white",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3301 8.66418L14.6624 11.9966M11.3301 11.9966L14.6624 8.66418",
    stroke: "white",
    strokeWidth: 1.33295,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9954,
    height: 15.9954,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitiateReturn);
export default __webpack_public_path__ + "static/media/initiateReturn.a8894fd18d119b2727f67ac9dfee967b.svg";
export { ForwardRef as ReactComponent };